'use client'

import starIcon from '@/shared/assets/star.svg'
import type { PostFeatured } from '@/shared/newsdb'
import { useI18n } from '@/shared/providers'

import { Carousel } from './carousel'
import { CarouselPost } from './post'
import { featuredCarouselRecipe } from './recipe'

type SliderBlockProps = {
    featuredPostList: PostFeatured[]
}

const styles = featuredCarouselRecipe()

export function FeaturedPostsCarousel({ featuredPostList }: SliderBlockProps) {
    if (featuredPostList.length === 0) {
        return null
    }

    return (
        <div className={styles.slider}>
            <CarouselHeader />

            <Carousel>
                {featuredPostList.map((post) => (
                    <CarouselPost key={post.id} post={post} />
                ))}
            </Carousel>
        </div>
    )
}

function CarouselHeader() {
    const { i18n } = useI18n()

    return (
        <h3 style={{ fontWeight: 'bold' }}>
            <img src={starIcon.src} height={54} width={54} alt="star" className={styles.star} />
            {i18n.TEXT_FEATURED.toUpperCase()}
        </h3>
    )
}
